export const TableHeader: React.FC<React.PropsWithChildren<object>> = ({ children }) => {
  return (
    <thead className="group/header sticky top-0 z-10 border-b border-slate-200 bg-slate-100/85">
      {children}
    </thead>
  );
};
